import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

interface PhotoBulkActionsProps {
  selectedCount: number;
  permissions: any;
  onBulkDownload: () => void;
  onBulkDelete: () => void;
  onClearSelection: () => void;
}

export const PhotoBulkActions: React.FC<PhotoBulkActionsProps> = memo(
  ({ selectedCount, permissions, onBulkDownload, onBulkDelete, onClearSelection }) => {
    const { t } = useTranslation();

    if (selectedCount === 0) return null;

    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
        <div className="flex items-center justify-between">
          <span className="text-red-800 font-medium">
            {selectedCount === 1
              ? t('photos.selection.photoSelected', { count: selectedCount })
              : t('photos.selection.photosSelected', { count: selectedCount })}
          </span>
          <div className="flex space-x-2">
            {permissions.bulk_download && (
              <button
                onClick={onBulkDownload}
                className="px-3 py-1 text-sm text-red-700 hover:bg-red-100 rounded-md transition-colors"
              >
                {t('photos.downloadAll')}
              </button>
            )}
            {permissions.delete && (
              <button
                onClick={onBulkDelete}
                className="px-3 py-1 text-sm text-red-700 hover:bg-red-100 rounded-md transition-colors"
              >
                {t('photos.deleteAll')}
              </button>
            )}
            <button
              onClick={onClearSelection}
              className="px-3 py-1 text-sm text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
            >
              {t('photos.clearSelection')}
            </button>
          </div>
        </div>
      </div>
    );
  }
);

PhotoBulkActions.displayName = 'PhotoBulkActions';
